module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-Australia-Website-w720.07b47a0c.webp";